import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Equity = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">📈 Equity</h1>
          <p className="text-muted-foreground">Your 40% stake tracker, company valuation trends</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Equity Dashboard</CardTitle>
            <CardDescription>Your 40% stake tracker, company valuation trends</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Equity content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Equity;